import { BgColorPicker } from './bg-color-picker'

export const inspector = {
  BgColorPicker,
}
